import { useContext } from 'preact/hooks'
import { Recovery } from '../index'
import { RecoveryApi } from '../../../api'

const useStepRequest = () => {
  const {
    type,
    phone,
    email,
    setIsLoading,
    switchStep,
    setError,
    handleReCaptchaVerify,
  } = useContext(Recovery)

  const step1 = async (login) => {
    if (!login) {
      login = type === 'phone' ? phone : email
    }
    setIsLoading(true)
    setError('')
    const token = await handleReCaptchaVerify()
    const data = new FormData()
    data.append(type, login)
    data.append('recaptcha', token)
    data.append('captcha_state', '0')
    data.append('recaptcha_version', 'V3')
    data.append('recaptcha_action', 'registration')
    data.append('isPersDomain', '1')
    const request =
      type === 'phone' ? RecoveryApi.stepPhone1 : RecoveryApi.stepEmail1
    request(data)
      .then((res) => {
        setIsLoading(false)
        if (res.status !== 200) {
          setError('Сервер временно недоступен')
          return
        }
        if (res.data.code !== 0 || res.data.code_text === 'ERROR') {
          if (res.data.code === 4601) {
            setError(`Счёт на домене: ${window.location.hostname} не найден`)
            return
          }
          if (res.data.key === 'i-rst-m1__na_goto_reset_by_phone') {
            setError(
              `Для данного аккаунта доступно восстановление только по <a href="#" id="switchToPhone">номеру телефона</a>`
            )
            return
          }
          if (res.data.key === 'i-rst-m1__na_goto_support') {
            setError(
              'Восстановление по email недоступно. Если вы забыли пароль, пожалуйста, обратитесь в службу поддержки'
            )
            return
          }
          if (res.data.key === 'i-rst-m1__email_not_found') {
            setError(`Счёт на домене: ${window.location.hostname} не найден`)
            return
          }
          setError(res.data.text)
          return
        }
        switchStep(1)
      })
      .finally(() => setIsLoading(false))
  }

  const step2 = (code) => {
    setIsLoading(true)
    setError('')
    const data = new FormData()
    data.append('code', code)
    const request =
      type === 'phone' ? RecoveryApi.stepPhone2 : RecoveryApi.stepEmail2
    request(data)
      .then((res) => {
        if (res.status !== 200) {
          setError('Сервер временно недоступен')
          return
        }
        if (res.data.code !== 0 || res.data.code_text === 'ERROR') {
          setError(res.data.text)
          return
        }
        switchStep(2)
      })
      .finally(() => setIsLoading(false))
  }

  const step3 = (data) => {
    setIsLoading(true)
    setError('')
    const request =
      type === 'phone' ? RecoveryApi.stepPhone3 : RecoveryApi.stepEmail3
    request(data)
      .then((res) => {
        if (res.status !== 200) {
          setError('Сервер временно недоступен')
          return
        }
        if (res.data.code !== 0 || res.data.code_text === 'ERROR') {
          setError(res.data.text)
          return
        }
        switchStep(3)
      })
      .finally(() => setIsLoading(false))
  }

  return {
    step1,
    step2,
    step3,
  }
}

export default useStepRequest
